import { FC } from 'react';
import { AppCard, AppPage } from '../../components/general';
import { Dropdown } from 'primereact/dropdown';
import { Checkbox } from 'primereact/checkbox';
import { TabView, TabPanel } from 'primereact/tabview';
import { PublicationComparison } from '../../utils/feeComparisonDiff';
import { HudLineDiffTab } from './comparison/HudLineDiffTab';
import { ConfigRuleDiffTab } from './comparison/ConfigRuleDiffTab';

export interface VersionOption {
  label: string;
  value: number | null;
}

interface ComparisonToolProps {
  versionOptions: VersionOption[];
  versionAId: number | null;
  versionBId: number | null;
  onVersionAChange: (id: number | null) => void;
  onVersionBChange: (id: number | null) => void;
  showDiffsOnly: boolean;
  onShowDiffsOnlyChange: (value: boolean) => void;
  jsonDiffsOnly: boolean;
  onJsonDiffsOnlyChange: (value: boolean) => void;
  comparison: PublicationComparison | null;
  isRefreshing: boolean;
}

export const ComparisonTool: FC<ComparisonToolProps> = ({
  versionOptions,
  versionAId,
  versionBId,
  onVersionAChange,
  onVersionBChange,
  showDiffsOnly,
  onShowDiffsOnlyChange,
  jsonDiffsOnly,
  onJsonDiffsOnlyChange,
  comparison,
  isRefreshing,
}) => {
  return (
    <AppPage
      title="Comparison Tool"
      breadcrumbs={[{ label: 'Dashboard', to: '/dashboard' }, { label: 'Fees', to: '/products/fees' }, { label: 'Comparison Tool' }]}
    >
      <AppCard>
        <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', alignItems: 'flex-end', marginBottom: 16 }}>
          <div style={{ flex: 1, minWidth: 220 }}>
            <label style={{ display: 'block', fontSize: 12, marginBottom: 4 }}>Publication A</label>
            <Dropdown
              value={versionAId}
              options={versionOptions}
              optionLabel="label"
              optionValue="value"
              onChange={(e) => onVersionAChange(e.value)}
              placeholder="Select publication"
              style={{ width: '100%' }}
            />
          </div>
          <div style={{ flex: 1, minWidth: 220 }}>
            <label style={{ display: 'block', fontSize: 12, marginBottom: 4 }}>Publication B</label>
            <Dropdown
              value={versionBId}
              options={versionOptions}
              optionLabel="label"
              optionValue="value"
              onChange={(e) => onVersionBChange(e.value)}
              placeholder="Select publication"
              style={{ width: '100%' }}
            />
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', paddingBottom: 8 }}>
            <Checkbox
              inputId="comparisonTool-showDiffsOnly"
              checked={showDiffsOnly}
              onChange={(e) => onShowDiffsOnlyChange(!!e.checked)}
            />
            <label htmlFor="comparisonTool-showDiffsOnly" style={{ fontSize: 13, cursor: 'pointer' }}>
              Show diffs only
            </label>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', paddingBottom: 8 }}>
            <Checkbox
              inputId="comparisonTool-jsonDiffsOnly"
              checked={jsonDiffsOnly}
              onChange={(e) => onJsonDiffsOnlyChange(!!e.checked)}
            />
            <label htmlFor="comparisonTool-jsonDiffsOnly" style={{ fontSize: 13, cursor: 'pointer' }}>
              Show diffs only within JSON fields
            </label>
          </div>
        </div>

        {isRefreshing && (
          <div style={{ fontSize: 12, color: 'var(--text-color-secondary)', marginBottom: 8 }}>Refreshing…</div>
        )}

        <TabView>
          <TabPanel header="HUD Line Diff">
            <HudLineDiffTab comparison={comparison} showDiffsOnly={showDiffsOnly} jsonDiffsOnly={jsonDiffsOnly} />
          </TabPanel>
          <TabPanel header="Configuration & Rule Diff">
            <ConfigRuleDiffTab comparison={comparison} showDiffsOnly={showDiffsOnly} jsonDiffsOnly={jsonDiffsOnly} />
          </TabPanel>
        </TabView>
      </AppCard>
    </AppPage>
  );
};

export default ComparisonTool;
